// Global Instructions Rule Applied!

import { TableFilterOptionsResponse } from '../rpc_models/get_table_filter_options_response.ts'
import { FundraisingPaginatedResponse } from '../../app_modules/fundraising/services/fundraisingService.ts'

export interface FilterValue {
  key: string
  value: string[] | string | { min?: number | string; max?: number | string }
}

export interface SortConfig {
  key: string
  direction: 'asc' | 'desc'
}

export interface ProspectRecord {
  id?: string
  [key: string]: any
}

export enum FundraisingTarget {
  PIPELINE = 'pipeline',
  FUNDRAISING = 'fundraising'
}

export interface FundraisingState {
  filterOptions: TableFilterOptionsResponse
  activeFilters: FilterValue[]
  activeSorting: SortConfig[]
  data: ProspectRecord[]
  hasMore: boolean
  currentPage: number
  pipeline: { data: ProspectRecord[]; selectedFundId?: string | null }
}

export interface SetFilterOptionsAction {
  type: 'fundraising/SET_FILTER_OPTIONS'
  payload: {
    response: TableFilterOptionsResponse
  }
  [key: string]: any
}

export interface SetFundraisingAction {
  type: 'fundraising/SET_FUNDRAISING'
  payload: {
    response: FundraisingPaginatedResponse
    target?: FundraisingTarget
  }
  [key: string]: any
}

export interface SetActiveFiltersAction {
  type: 'fundraising/SET_ACTIVE_FILTERS'
  payload: {
    filters: FilterValue[]
  }
  [key: string]: any
}

export interface SetActiveSortingAction {
  type: 'fundraising/SET_ACTIVE_SORTING'
  payload: {
    sorting: SortConfig[]
  }
  [key: string]: any
}

export interface ClearActiveFiltersAction {
  type: 'fundraising/CLEAR_ACTIVE_FILTERS'
  payload: {}
  [key: string]: any
}

export interface ClearActiveSortingAction {
  type: 'fundraising/CLEAR_ACTIVE_SORTING'
  payload: {}
  [key: string]: any
}

export interface UpdateProspectRecordAction {
  type: 'fundraising/UPDATE_PROSPECT_RECORD'
  payload: {
    prospectId: string
    updates: Record<string, any>
  }
  [key: string]: any
}

export interface AddProspectAction {
  type: 'fundraising/ADD_PROSPECT'
  payload: {
    prospect: ProspectRecord
  }
  [key: string]: any
}

export interface AppendFundraisingAction {
  type: 'fundraising/APPEND_FUNDRAISING'
  payload: {
    response: FundraisingPaginatedResponse
  }
  [key: string]: any
}

export interface UpdateRecordBySearchAction {
  type: 'UPDATE_RECORD_BY_SEARCH'
  payload: {
    searchField: string
    searchValue: any
    updates: Record<string, any>
  }
  [key: string]: any
}

export interface SetPipelineSelectedFundAction {
  type: 'fundraising/SET_PIPELINE_SELECTED_FUND'
  payload: { selectedFundId: string | null }
  [key: string]: any
}

export interface RemoveProspectFromListAction {
  type: 'fundraising/REMOVE_PROSPECT_FROM_LIST'
  payload: { prospectId: string }
  [key: string]: any
}

export type FundraisingAction =
  | SetFilterOptionsAction
  | SetFundraisingAction
  | SetActiveFiltersAction
  | SetActiveSortingAction
  | ClearActiveFiltersAction
  | ClearActiveSortingAction
  | UpdateProspectRecordAction
  | AddProspectAction
  | AppendFundraisingAction
  | UpdateRecordBySearchAction
  | SetPipelineSelectedFundAction
  | RemoveProspectFromListAction
